module.exports = __webpack_public_path__ + "img/m5.bad9fa58.png";